<template>
  <div>
    <div
      class="mb-1 font-roboto text-[26px] font-semibold leading-8 tracking-wider"
    >
      Периоды
    </div>
    <div class="relative -mx-4 overflow-hidden px-4">
      <Swiper
        :breakpoints="breakpoints"
        :space-between="20"
        class="periods-slider"
        @swiper="onSwiper"
        @slide-change="syncEdges"
        @resize="syncEdges"
      >
        <SwiperSlide
          v-for="card in periods"
          :key="card.id"
          class="!h-auto py-4"
        >
          <div
            class="bg-white flex size-full flex-col gap-5 rounded-xl p-10 shadow-[0px_0px_12px_0px_rgba(0,0,0,0.07)] transition-all duration-300 ease-in-out hover:shadow-[0px_0px_24px_0px_rgba(0,0,0,0.14)]"
          >
            <div class="flex items-start gap-4">
              <SvgIcon
                v-if="getPeriodIcon(card)"
                :name="getPeriodIcon(card)"
                class="size-8 shrink-0"
              />
              <div
                class="font-roboto text-[24px] font-semibold leading-8 tracking-[1.2px]"
              >
                {{ card.title }}
              </div>
            </div>
            <NuxtLink
              class="mt-auto text-[16px] font-medium leading-4 text-new-card--title-black"
              :to="{
                path: '/encyclopedia/catalog',
                query: { period: card.slug, from: 'periods' },
              }"
            >
              Подробнее
            </NuxtLink>
          </div>
        </SwiperSlide>
      </Swiper>
      <SlidersSliderControl
        type="prev"
        class="absolute left-0 top-1/2 z-10 hidden -translate-y-1/2 md:block"
        :class="isBeginning ? 'opacity-50' : 'cursor-pointer'"
        @click="slidePrev()"
      />
      <SlidersSliderControl
        type="next"
        class="absolute right-0 top-1/2 z-10 hidden -translate-y-1/2 md:block"
        :class="isEnd ? 'opacity-50' : 'cursor-pointer'"
        @click="slideNext()"
      />
    </div>
  </div>
</template>

<script setup>
import 'swiper/css';

import { Swiper, SwiperSlide } from 'swiper/vue';

import api from '~~/services/api/api';

const { onSwiper: bindSwiper, slideNext, slidePrev } = useSwiper();

const isBeginning = ref(true);
const isEnd = ref(false);

const syncEdges = (instance) => {
  isBeginning.value = instance?.isBeginning ?? true;
  isEnd.value = instance?.isEnd ?? false;
};

const onSwiper = (instance) => {
  bindSwiper(instance);
  syncEdges(instance);
  instance.on('slidesLengthChange', () => syncEdges(instance));
};

const PERIOD_ICONS_BY_TITLE = [
  [/первобыт/i, 'primitive'],
  [/древн/i, 'ancient-world'],
  [/антич/i, 'antiquity'],
  [/средн/i, 'middle-ages'],
  [/новейш/i, 'contemporary'],
  [/нов/i, 'modern'],
];

const PERIOD_ICONS_BY_ID = {
  1: 'primitive',
  2: 'ancient-world',
  3: 'middle-ages',
  4: 'modern',
  5: 'contemporary',
  6: 'antiquity',
};

const getPeriodIcon = (period) => {
  const byTitle = PERIOD_ICONS_BY_TITLE.find(([pattern]) =>
    pattern.test(period?.title ?? ''),
  );
  const icon = byTitle?.[1] ?? PERIOD_ICONS_BY_ID[period?.id];

  return icon ? `periods/${icon}` : '';
};

const { data: periods } = useAsyncData('wiki-periods', async () => {
  const res = await api.wikis.getWikisPeriods();
  return res?.data?.data ?? null;
});

const breakpoints = {
  768: {
    slidesPerView: 2,
  },
  1280: {
    slidesPerView: 3.15,
  },
};
</script>

<style lang="scss" scoped>
:deep(.swiper) {
  overflow: visible !important;
}
</style>
